import React, { useState } from "react";
import { Archive, ChevronRight, History, CalendarPlus, ChartNoAxesCombined } from "lucide-react";

const ArchivedGameSubpages = ({ pageKey, page }) => {
  const [isSubOpen, setIsSubOpen] = useState(false);

  console.log(pageKey);

  return (
    <div className="w-full">
      <button
        onClick={() => setIsSubOpen(!isSubOpen)}
        className="flex text-sm items-center w-full px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-all"
      >
        <span className="flex-1">{pageKey}</span>
        <ChevronRight className={`w-4 h-4 transform transition-transform ${isSubOpen ? "rotate-90" : ""}`} />
      </button>

      <div className={`grid transition-all overflow-hidden ${isSubOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
        <div className="overflow-hidden">
          <a href={`/${pageKey}/planning`} className="flex items-center px-6 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white">
            <CalendarPlus className="w-4 h-4 mr-2" />
            <span>Planning</span>
          </a>
          <a href={`/${pageKey}/statistics`} className="flex items-center px-6 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white">
            <ChartNoAxesCombined className="w-4 h-4 mr-2" />
            <span>Statistics</span>
          </a>
        </div>
      </div>
    </div>
  );
};

const ArchivedLinkDrop = ({ pages }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center w-full px-4 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-all">
        <Archive className="w-6 h-6 mr-3" />
        <span className="flex-1 font-medium">Archive</span>
      </button>

      <div className={`grid transition-all overflow-hidden ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
        <div className="overflow-hidden">
          {Object.entries(pages).map(([pageKey, page]) => (
            <ArchivedGameSubpages key={pageKey} pageKey={pageKey} page={page} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArchivedLinkDrop;
